var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attachments-wrapper" }, [
    _c("div", { staticClass: "attachments-header" }, [
      _c("div", { staticClass: "attachment-count" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("attachment")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$t("mail.emailAttachments", { count: _vm.attachments.length })
            )
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "attachments-list" },
      _vm._l(_vm.attachments, function (attachment) {
        return _c("attachment-item", {
          key: attachment.name || attachment.id,
          attrs: { attachment: attachment },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }